import React, { useEffect } from "react";
import { toPng } from "html-to-image";
import { jsPDF } from "jspdf";

import "./Invoice-Pdf-Generator.css";

const InvoicePdfGenerator = ({ invoiceToDownload }) => {
  const { invoiceNumber, Invoice_lines, subTotal, total } =
    invoiceToDownload || {};

  const downloadPdf = () => {
    toPng(document.getElementById("divToPrint"), { quality: 1 }).then(function (
      dataUrl
    ) {
      var link = document.createElement("a");
      link.download = "my-image-name.jpeg";
      const pdf = new jsPDF();
      const imgProps = pdf.getImageProperties(dataUrl);
      const pdfWidth = 210;
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(dataUrl, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("OneRoute Invoice.pdf");
    });
  };

  useEffect(() => {
    if (invoiceToDownload) downloadPdf();
  }, [invoiceToDownload]);

  return (
    <div>
      <div id="divToPrint" className="pdf_generator_container">
        <main className="main">
          <div className="content">
            <p>Here's a detailed breakdown of your OneRoute Invoice.</p>

            <div className="invoice">
              <h6>Invoice - #{invoiceNumber}</h6>

              <div className="list-div">
                {Invoice_lines?.map((item, i) => (
                  <p key={i}>
                    {item?.name}
                    <span>NGN {item?.amount}</span>
                  </p>
                ))}
              </div>

              <div className="list-div total-div">
                <p>
                  Sub Total<span>NGN {subTotal}</span>
                </p>
                <p>
                  Total<span>NGN {total}</span>
                </p>
                <p>
                  Estimated Total<span>NGN {total}</span>
                </p>
              </div>
              <br />
            </div>
          </div>

          <div className="footer">
            <p>1a Mojidi Street, Ikeja, Lagos Nigeria.</p>
            <p>
              Oneroute.io is a property of Route communications Limited, a
              company duly registered with CAC with RC Number: 0101010.
              Oneroute.io provides messeging services under a Cooperative
              License with a registration number 15845. Both Route
              communications and ASB Technology Solutions Ltd are legal entities
              in Nigeria.
            </p>
          </div>
        </main>
      </div>
    </div>
  );
};

export default InvoicePdfGenerator;
